module.exports = __webpack_public_path__ + "static/media/fulloryx.a17685c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fulloryx.jpg
// module id = ./src/img/fulloryx.jpg
// module chunks = 0